import Axios from "axios";
import { useQuery } from "react-query";
import { scenarioKeys } from "src/query-keys";
import { Scenario } from "src/types";

export function useScenarios(caseId: number | string, refetchInterval = false as false | number) {
  async function queryFn(caseId: number | string): Promise<Scenario[]> {
    const result = await Axios.get(`/planning-api/cases/${caseId}/scenarios`);
    return result.data;
  }

  return useQuery<Scenario[], Error>(scenarioKeys.all(caseId), () => queryFn(caseId), { refetchInterval });
}
